import parse from 'url-parse';

import config, { FeatureToggleState, switchContent } from 'shared/config';
import ICONS from 'components/Icons';

const INSURANCE_BASE_URL = 'https://www.coles.com.au/insurance';

const IMPORTANT_INFORMATION_URL = switchContent({
  oldContent: 'https://coles.com.au/insurance-information',
  newContent:
    'https://www.coles.com.au/insurance/existing-customers/important-information',
});

const FINANCIAL_SERVICES_GUIDE_URL = switchContent({
  oldContent:
    'https://financialservices.coles.com.au/insurance/about-our-insurance/important-information#FSG',
  newContent:
    'https://www.coles.com.au/insurance/existing-customers/important-information',
});

const KEY_FACT_SHEET_URL = switchContent({
  oldContent:
    'https://financialservices.coles.com.au/insurance/about-our-insurance/important-information#PDS',
  newContent:
    'https://www.coles.com.au/insurance/existing-customers/important-information',
});

const PREMIUM_EXCESS_DISCOUNTS_URL =
  'https://www.coles.com.au/insurance/existing-customers/important-information';

const PRODUCT_DISCLOSURE_STATEMENT_URL = switchContent({
  oldContent: 'https://www.coles.com.au/insurance/about-our-insurance#PDS',
  newContent:
    'https://www.coles.com.au/insurance/existing-customers/important-information',
});

const TERMS_AND_CONDITIONS = `${process.env.PUBLIC_URL}/termsandconditions`;

const PRIVACY_POLICY_URL = switchContent({
  oldContent:
    'https://financialservices.coles.com.au/insurance/about-our-insurance/important-information#PrivacyPolicy',
  newContent:
    'https://www.coles.com.au/insurance/existing-customers/important-information/privacy-policy',
});

const NSW_REVENUE_URL = 'http://www.revenue.nsw.gov.au/taxes/insurance';

const ROADSIDE_ASSISTANCE_TERMS_CONDITIONS_URL =
  'https://www.coles.com.au/insurance/car-insurance/roadside-assistance';

const SPECIAL_OFFERS_URL =
  'https://coles.com.au/coles-insurance-online-discount';

const CAR_INSURANCE_PAGE_URL =
  'https://www.coles.com.au/insurance/car-insurance';

const CAR_INSURANCE_QUOTE_URL =
  'https://general-insurance.coles.com.au/digitalcoles/motor';

const LANDLORD_INSURANCE_PAGE_URL =
  'https://www.coles.com.au/insurance/landlord-insurance';

const LANDLORD_INSURANCE_QUOTE_URL =
  config.featureToggles.landlord === FeatureToggleState.ON
    ? 'https://general-insurance.coles.com.au/digitalcoles/landlord'
    : 'https://general-insurance.coles.com.au/landlord/your-property';

const HOME_INSURANCE_PAGE_URL =
  'https://www.coles.com.au/insurance/home-insurance';

const HOME_INSURANCE_QUOTE_URL =
  'https://general-insurance.coles.com.au/digitalcoles/home';

const LOGIN_URL =
  'https://general-insurance.coles.com.au/onlineselfservice/login';

const FIND_AN_INSURER = 'https://findaninsurer.com.au/';

const HOME_CONTENTS_SUM_INSURED =
  'https://www.homecontents.com.au/index.php?c=web_intro&profile=suminsured_coles_rwd';

const SUM_INSURED_ESTIMATE_CALCULATOR_URL =
  'https://sumsure.cordell.com.au/#/products/7/profiles/125?partner=12505';

const CAMPAIGN_TC_LINK = 'https://www.coles.com.au/insurance/competitions';

const PAYMENT_PORTAL_URL =
  'https://general-insurance.coles.com.au/digitalcoles/payment';

const T_AND_C_ONLINE_INSURANCE_URL =
  'https://www.coles.com.au/coles-insurance-online-discount';

const CHROME_BROWSER_URL = 'https://www.google.com/chrome/';

const FIREFOX_BROWSER_URL = 'https://www.mozilla.org/en-US/firefox/new/';

const EDGE_BROWSER_URL =
  'https://www.microsoft.com/en-us/windows/microsoft-edge';

const SAFARI_BROWSER_URL = 'https://www.apple.com/au/safari/';

const COLESINSURANCE_MAIL_TO_ID = 'colesinsurance@iag.com.au';

const COLES_CONTACT_CENTER = 'https://www.coles.com.au/insurance/contact-us';

export const financialServiceGuide = {
  url: FINANCIAL_SERVICES_GUIDE_URL,
  text: 'Financial Services Guide',
};

export const keyFactSheet = {
  url: KEY_FACT_SHEET_URL,
  text: 'Key Fact Sheet',
};

export const productDisclosureStatement = {
  url: PRODUCT_DISCLOSURE_STATEMENT_URL,
  text: 'Product Disclosure Statement',
};

export const termsAndConditions = {
  url: TERMS_AND_CONDITIONS,
  text: 'Terms & Conditions',
};

export const privacyPolicyInfo = {
  url: PRIVACY_POLICY_URL,
  text: 'Privacy Statement',
};

export const chrome = {
  url: CHROME_BROWSER_URL,
  text: 'Google Chrome',
  imgSrc: ICONS.BROWSERS.CHROME,
  alt: 'link to download chrome browser',
};

export const firefox = {
  url: FIREFOX_BROWSER_URL,
  text: 'Mozilla Firefox',
  imgSrc: ICONS.BROWSERS.FIREFOX,
  alt: 'link to download firefox browser',
};
export const edge = {
  url: EDGE_BROWSER_URL,
  text: 'Microsoft Edge',
  imgSrc: ICONS.BROWSERS.EDGE,
  alt: 'link to download edge browser',
};
export const safari = {
  url: SAFARI_BROWSER_URL,
  text: 'Safari',
  imgSrc: ICONS.BROWSERS.SAFARI,
  alt: 'link to download safari browser',
};

export const format1300Number = (number: string): string => {
  if (number.length !== 10) {
    return '';
  }
  return `${number.substring(0, 4)} ${number.substring(
    4,
    7
  )} ${number.substring(7)}`;
};

export const toDisplayUrl = (url: string): string => {
  const parsedUrl = parse(url);
  return `${parsedUrl.hostname}${parsedUrl.pathname}`;
};

const CUSTOMER_CARE_NUMBER = '1300265374';

export const nswRevenueUrl = () => NSW_REVENUE_URL;
export const insuranceBaseUrl = () => INSURANCE_BASE_URL;
export const importantInformationUrl = () => IMPORTANT_INFORMATION_URL;
export const productDisclosureStatementUrl = () =>
  PRODUCT_DISCLOSURE_STATEMENT_URL;
export const privacyPolicy = () => PRIVACY_POLICY_URL;
export const roadsideAssistTermsCondition = () =>
  ROADSIDE_ASSISTANCE_TERMS_CONDITIONS_URL;
export const specialOffersUrl = () => SPECIAL_OFFERS_URL;
export const carInsurancePageUrl = () => CAR_INSURANCE_PAGE_URL;
export const carInsuranceQuoteUrl = () => CAR_INSURANCE_QUOTE_URL;
export const landlordInsurancePageUrl = () => LANDLORD_INSURANCE_PAGE_URL;
export const landlordInsuranceQuoteUrl = () => LANDLORD_INSURANCE_QUOTE_URL;
export const homeInsurancePageUrl = () => HOME_INSURANCE_PAGE_URL;
export const homeInsuranceQuoteUrl = () => HOME_INSURANCE_QUOTE_URL;
export const loginUrl = () => LOGIN_URL;
export const findAnInsurerUrl = () => FIND_AN_INSURER;
export const homeContentsSumInsuredUrl = () => HOME_CONTENTS_SUM_INSURED;

export const customerCareNumber = () => CUSTOMER_CARE_NUMBER;
export const sumInsuredEstimatingCalculatorUrl = () =>
  SUM_INSURED_ESTIMATE_CALCULATOR_URL;

export const campaignTCLink = () => CAMPAIGN_TC_LINK;
export const paymentPortalUrl = () => PAYMENT_PORTAL_URL;
export const tAndCInsDiscountUrl = () => T_AND_C_ONLINE_INSURANCE_URL;
export const colesInsuranceMailToId = () => COLESINSURANCE_MAIL_TO_ID;
export const premiumExcessDiscountUrl = () => PREMIUM_EXCESS_DISCOUNTS_URL;
export const colesContactCenter = () => COLES_CONTACT_CENTER;
